(() => {
  const initArticleLayout = () => {
    const shell = document.querySelector('[data-rp-article-shell]');
    if (!shell) return;

    const content = shell.querySelector('.rp-article-main');
    const headings = Array.from(content?.querySelectorAll('h2') || []);
    const toc = shell.querySelector('[data-rp-toc]');
    const wordCount = (content?.textContent || '').trim().split(/\s+/).filter(Boolean).length;
    const minutes = Math.max(1, Math.ceil(wordCount / 220));
    const readingTime = shell.querySelector('[data-rp-reading-time]');
    if (readingTime) readingTime.textContent = String(minutes);

    if (toc && headings.length) {
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `article-section-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        toc.appendChild(item);
      });
    } else {
      toc?.closest('.rp-article-toc')?.remove();
    }

    const ring = shell.querySelector('.rp-reading-ring');
    const progressText = shell.querySelector('[data-rp-progress-text]');
    const updateProgress = () => {
      const rect = content.getBoundingClientRect();
      const start = window.scrollY + rect.top - window.innerHeight * .3;
      const distance = Math.max(1, content.offsetHeight - window.innerHeight * .45);
      const progress = Math.min(100, Math.max(0, ((window.scrollY - start) / distance) * 100));
      ring?.style.setProperty('--rp-progress', `${progress * 3.6}deg`);
      if (progressText) progressText.textContent = `${Math.round(progress)}%`;

      let current = headings[0];
      headings.forEach((heading) => {
        if (heading.getBoundingClientRect().top <= 180) current = heading;
      });
      toc?.querySelectorAll('a').forEach((link) => {
        link.classList.toggle('is-active', current && link.getAttribute('href') === `#${current.id}`);
      });
    };

    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();

    const copyButton = shell.querySelector('[data-rp-copy-link]');
    const copyStatus = shell.querySelector('[data-rp-copy-status]');
    copyButton?.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        if (copyStatus) copyStatus.textContent = 'Link copied';
      } catch (error) {
        if (copyStatus) copyStatus.textContent = 'Copy failed';
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleLayout, { once: true });
  } else {
    initArticleLayout();
  }
})();
